import PropTypes from "prop-types"
import { useCallback } from "react"
import { useDispatch } from "react-redux"

import { setGiftBundle } from "areas/cart/store/actions"
import { isTestMode } from "helpers/application"

export default function withGiftBundles(WrappedComponent) {
  const GiftBundles = (props) => {
    const { handleGiftBundle, item, itemGiftBundle } = props
    const selectedGiftBundle =
      itemGiftBundle ||
      item?.addons?.find((addon) => addon.addon_type === "GIFT_BUNDLE")

    const dispatch = useDispatch()

    const selectGiftBundle = useCallback(
      (bundle, callbacks) => {
        dispatch(setGiftBundle(item.id, bundle, "cart", callbacks))
      },
      [item.id]
    )

    return (
      <WrappedComponent
        {...props}
        handleGiftBundle={(giftBundle, callbacks) => {
          if (!isTestMode && giftBundle) {
            dataLayer.push({
              event: "added-gift-bundle-to-cart",
              giftPackaging: giftBundle.id,
              giftType: "GIFT_BUNDLE",
            })
          }

          if (handleGiftBundle) {
            handleGiftBundle(giftBundle, callbacks)
          } else {
            selectGiftBundle(giftBundle, callbacks)
          }
        }}
        selectedGiftBundle={selectedGiftBundle}
      />
    )
  }

  GiftBundles.propTypes = {
    handleGiftBundle: PropTypes.func,
    item: PropTypes.object,
    itemGiftBundle: PropTypes.object,
  }

  return GiftBundles
}
